import { ReportScreen } from "@/features/report-screen";

/** The rep report (ADR-074 in platform): how each rep spent the time, and what came of it. Its screen is `features/report-screen.tsx`, shared with
 *  the other two reports. */
export function RepReportPage() {
  return <ReportScreen kind="reps" />;
}
